export default __webpack_public_path__ + "static/media/image2.cf3b718c.svg";